import actions from './actions'

export default function ProvisionsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PROVISION:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PROVISION:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PROVISION:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PROVISION:
      return {
        ...state,
        editing: { provision: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PROVISION_RECIEVED ||
      actions.UPDATE_PROVISION_RECIEVED ||
      actions.DELETE_PROVISION_RECIEVED:
      return {
        ...state,
        editing: { provision: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
